import './styles/date-time-range-filter.scss'

import React, { useEffect, useState } from 'react'
import PropTypes  from 'prop-types'
import { Form } from 'semantic-ui-react'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'

class CustomInput extends React.Component {
  render() {
    return <Form.Input {...this.props} />
  }
}

const initialState = {
  startDate: null,
  endDate: null,
}

const DateTimeRangeFilter = ({ defaultFilterConfig: { after, before } = {}, onChange }) => {
  const [startDate, setStartDate] = useState((after && new Date(after)) || initialState.startDate)
  const [endDate, setEndDate] = useState((before && new Date(before)) || initialState.endDate)

  const clearDates = () => {
    setStartDate(initialState.startDate)
    setEndDate(initialState.endDate)
    onChange({})
  }

  useEffect(() => {
    if (startDate && endDate) {
      onChange({ before: endDate.getTime(), after: startDate.getTime() })
    }
  }, [startDate, endDate])

  return (
    <div className="date-time-range-filter">
      <DatePicker
        containerClassName="ui input"
        selected={startDate}
        onChange={(date) => setStartDate(date)}
        selectsStart
        startDate={startDate}
        endDate={endDate}
        placeholderText="Start date"
        timeInputLabel="Time:"
        dateFormat="MM/dd/yyyy h:mm aa"
        timeFormat="p"
        showTimeInput
        customInput={<CustomInput placeholder="Start date" />}
      />
      <DatePicker
        containerClassName="ui input"
        selected={endDate}
        onChange={(date) => setEndDate(date)}
        selectsEnd
        endDate={endDate}
        minDate={startDate}
        placeholderText="End date"
        timeInputLabel="Time:"
        dateFormat="MM/dd/yyyy h:mm aa"
        timeFormat="p"
        showTimeInput
        customInput={<CustomInput action={{ icon: 'delete', onClick: clearDates }} />}
      />
    </div>
  )
}

DateTimeRangeFilter.propTypes = {
  defaultFilterConfig: PropTypes.shape({
    after: PropTypes.number,
    before: PropTypes.number,
  }),
  onChange: PropTypes.func.isRequired,
}

export default DateTimeRangeFilter
